module.exports = "https://cdn.realtymogul.com/static/media/chart_passive.4e1b28ea.jpg";